/* ==================================================
=            Define Families and sizes.             =
================================================== */
const CONSTANTS = require('./constants.js');
/* ----------  Font Families  ---------- */
const fonts = CONSTANTS.fonts;
/* ----------  Font Sizes  ---------- */
// Normal Monogram
const sizeMonogram = CONSTANTS.sizeMonogram;
const sizeStandardMonogram = CONSTANTS.sizeStandardMonogram;
/* ----------  UV Map Sizes  ---------- */
const uvMap = CONSTANTS.uvMap;
const nonMonogramUvMap = CONSTANTS.nonMonogramUvMap;
/* =====  End of Define Families and Sizes.  ====== */
/* ==========================================================
=            special method to render Deco Font             =
========================================================== */
/**
 *
 * The method for the Deco font is needed because the fonts provided
 * are not rendering at the proper size, the fonts have some issues.
 *
 */

function drawDecoMonogramText(ctx, options) {
  let first = '',
    second = '',
    last = '',
    size;
  const initials = options.initials,
    color = options.color,
    fontFamilyFirst = fonts.decoLeft,
    fontFamilyMiddle = fonts.decoMiddle,
    fontFamilyLast = fonts.decoRigth,
    centerFactor = 2.3;
  const sizes = CONSTANTS.fontid[options.fontid].size;
  const order = CONSTANTS.fontid[options.fontid].order;
  switch (order.length) {
    case 1:
      first = options.initials.charAt(order[0]);
      break;
    case 2:
      first = options.initials.charAt(order[0]);
      second = options.initials.charAt(order[1]);
      if (!second) {
        second = options.initials.charAt(1);
      }
      break;
    case 3:
      first = options.initials.charAt(order[0]);
      second = options.initials.charAt(order[1]);
      last = options.initials.charAt(order[2]);
      break;
  }
  if (initials.length === 3) {
    size = sizes[1] / 1.77;
  } else {
    size = sizes[1] / centerFactor;
  }
  const bigSize = size * centerFactor,
    bigY = uvMap.height / 2 + bigSize / 2;
  let normalSize = size * 1.21,
    normalY = uvMap.height / 2 + normalSize / 2,
    xCorrect = 0.85;
  // we need to measure text with an specific font size.
  ctx.font = normalSize + 'px ' + fontFamilyLast;
  const firstWidth = ctx.measureText(first).width,
    lastWidth = ctx.measureText(last).width;
  ctx.fillStyle = color;
  if (sizes.length === 3) {
    // fill in middle initial
    const middleWidth = ctx.measureText(second).width;
    ctx.font = bigSize + 'px ' + fontFamilyMiddle;
    // middle letter needs to add the extra 14 to get totally centered.
    ctx.fillText(second, uvMap.width / 2 - middleWidth / 2 + (size / 10), bigY);
  } else {
    last = second;
    xCorrect = 1.8;
    normalSize = bigSize;
    normalY = bigY;
  }
  // fill in first initial
  ctx.font = normalSize + 'px ' + fontFamilyFirst;
  ctx.fillText(first, ((uvMap.width - lastWidth) / 2) - (xCorrect * firstWidth), normalY);
  // fill in last initial
  ctx.font = normalSize + 'px ' + fontFamilyLast;
  ctx.fillText(last, ((uvMap.width - lastWidth) / 2) + (xCorrect * lastWidth), normalY);
  // store the initials
  const storeInitials = (sizes[0] ? first : '') + (sizes[1] ? second : '') + (sizes[2] ? last : '');
  options.app.actions.storeInitials(storeInitials, options.absoluteParent);
  options.app.actions.storeInitialsMinLength({
    minLength: CONSTANTS.fontid[options.fontid].minLength,
    fontId: options.fontid
  });

  const aliasChange = options.app.appUtils.isSimpleCYO() ?
    options.absoluteParent.replace('_location', '_text_entry') :
    options.absoluteParent + '_monogram';
  const change = {
    ca: { alias: aliasChange },
    av: { text: storeInitials }
  };

  options.app.updateRecipeOms.updateOms(aliasChange, change);
}



/* =====  End of special method to render Deco Font  ====== */


/* ----------  Normal Monogram  ---------- */
function drawMonogramText(ctx, options) {
  let first = options.first;
  let middle = options.middle;
  let last = options.last;
  const color = options.color;
  const fontFamily = options.font;
  if (!last) {
    // if we only have 2 letters, center them.
    last = middle;
    middle = '';
  }
  if (!middle && !last) {
    // if we only have one letter, show only the center letter.
    middle = first;
    first = '';
  }
  const size = sizeMonogram;
  ctx.font = size + 'px ' + fontFamily;
  ctx.fillStyle = color;

  const middleWidth = ctx.measureText(middle).width;
  const firstWidth = ctx.measureText(first).width;
  const yPosition = uvMap.height / 2 + (size / 3);

  ctx.fillText(first, ((uvMap.width - middleWidth) / 2) - firstWidth, yPosition);
  ctx.fillText(middle, uvMap.width / 2 - middleWidth / 2, yPosition);
  ctx.fillText(last, ((uvMap.width - middleWidth) / 2) + middleWidth, yPosition);
  options.app.actions.storeInitials(first + middle + last);
  options.app.actions.storeInitialsMinLength({
    minLength: CONSTANTS.fontid[options.fontid].minLength,
    fontId: options.fontid
  });
}

function drawBigMonogram(ctx, options) {
  if (!options.initials) {
    return;
  }

  const font = /^[BC]/.test(options.fontid) ? options.fontid.substring(4, 7) : options.fontid.substring(3, 6);
  if (font === 'DEC') {
    return drawDecoMonogramText(ctx, options);
  }
  const fontFamily = fonts[font];
  const color = options.color;
  const sizes = CONSTANTS.fontid[options.fontid].size;
  let sizeCenter,
    sizeLeft,
    sizeRight;

  const order = CONSTANTS.fontid[options.fontid].order;
  let first = '',
    middle = '',
    last = '';
  switch (order.length) {
    case 1:
      first = options.initials.charAt(order[0]);
      break;
    case 2:
      first = options.initials.charAt(order[0]);
      middle = options.initials.charAt(order[1]);
      if (!middle) {
        middle = options.initials.charAt(1);
      }
      break;
    case 3:
      first = options.initials.charAt(order[0]);
      middle = options.initials.charAt(order[1]);
      last = options.initials.charAt(order[2]);
      break;
  }
  let yCorrection = 0,
    sizeFactor = 1;
  if (font === 'SCR') {
    yCorrection = -4;
    sizeFactor = 1.35;
  } else if (font === 'GOT') {
    sizeFactor = 1.22;
  }
  switch (sizes.length) {
    case 1:
      sizeCenter = sizes[0] * sizeFactor;
      break;
    case 2:
      // in the case of 1 letter entered, the letter will go as middle.
      // So we need to have an available size.
      sizeCenter = sizes[1] * sizeFactor;
      sizeLeft = sizes[0] * sizeFactor;
      sizeRight = sizes[1] * sizeFactor;
      break;
    default:
      sizeCenter = sizes[1] * sizeFactor;
      sizeLeft = sizes[0] * sizeFactor;
      sizeRight = sizes[2] * sizeFactor;
      break;
  }
  if (!last) {
    // if we only have 2 letters, center them.
    last = middle;
    middle = '';
  }
  if (!middle && !last) {
    // if we only have one letter, show only the center letter.
    middle = first;
    first = '';
  }
  ctx.font = sizeCenter + 'px ' + fontFamily;
  const middleWidth = ctx.measureText(middle).width;
  ctx.fillStyle = color;
  ctx.fillText(middle, uvMap.width / 2 - middleWidth / 2, uvMap.height / 2 + sizeCenter / 3 + yCorrection);

  ctx.font = sizeLeft + 'px ' + fontFamily;
  const firstWidth = ctx.measureText(first).width;
  ctx.fillText(first, ((uvMap.width - middleWidth) / 2) - firstWidth, uvMap.height / 2 + sizeLeft / 3);
  ctx.font = sizeRight + 'px ' + fontFamily;
  ctx.fillText(last, ((uvMap.width - middleWidth) / 2) + middleWidth, uvMap.height / 2 + sizeRight / 3);
  // store the initials
  const storeInitials = (sizeLeft ? first : '') + (sizeCenter ? middle : '') + (sizeRight ? last : '');
  options.app.actions.storeInitials(storeInitials, options.absoluteParent);
  options.app.actions.storeInitialsMinLength({
    minLength: CONSTANTS.fontid[options.fontid].minLength,
    fontId: options.fontid
  });

  const aliasChange = options.app.appUtils.isSimpleCYO() ?
    options.absoluteParent.replace('_location', '_text_entry') :
    options.absoluteParent + '_monogram' + (options.lineNum ? options.lineNum : '');
  const change = {
    ca: { alias: aliasChange },
    av: { text: storeInitials }
  };
  options.app.updateRecipeOms.updateOms(aliasChange, change);
}

function drawNonClothingText(ctx, options) {
  const color = options.color;
  const font = /^[BC]/.test(options.fontid) ? options.fontid.substring(4, 7) : options.fontid.substring(3, 6);
  const fontFamily = fonts[font];
  const size = sizeStandardMonogram;
  const mapDimensions = options.uvMapType === 'standard' ? nonMonogramUvMap : uvMap;

  ctx.font = size + 'px ' + fontFamily;
  ctx.fillStyle = color;

  // const yPosition = mapDimensions.height/2+(size/3);
  const yPosition = mapDimensions.height / 2;
  const xPosition = mapDimensions.width / 2;

  options.app.actions.storeInitials(options.text, options.absoluteParent);

  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(options.text, xPosition, yPosition);
}

module.exports = {
  drawMonogramText,
  drawBigMonogram,
  drawDecoMonogramText,
  drawNonClothingText
};
